module.exports = __webpack_public_path__ + "media/images/FTRP_SME_mobile_banner-1801cf5e2213630a87a69675931b097a.jpg";